import { Consumer } from '@vendasta/billing';

export enum DiscountConsumer {
  RETAIL = 'retail',
  WHOLESALE = 'reseller',
}

export function discountConsumerToApi(dc: DiscountConsumer): Consumer {
  switch (dc) {
    case DiscountConsumer.RETAIL:
      return Consumer.CONSUMER_RETAIL;
    case DiscountConsumer.WHOLESALE:
      return Consumer.CONSUMER_WHOLESALE;
  }
}
